import { VBtn } from 'vuetify/lib'

export const videoRoute =  {
  template: `
    <v-btn
      text
      :style="getLinkStyle()"
      class="text-link"
      :to="{ name: 'watch', params: {sectionId: sectionId, blockId: blockId, videoId: video.id }}"
    >
      <slot name="link">{{ video.title }}</slot>
    </v-btn>
  `,
  components: {
    VBtn
  },
  methods: {
    getLinkStyle() {
      return {
        'white-space': 'nowrap',
        'overflow': 'hidden',
        'text-overflow': 'ellipsis',
        'color': this.fontColor,
      //  'text-decoration': 'none'
      };
    }
  },
  props: [
    'video',
    'sectionId',
    'blockId',
    'fontColor'
  ]
};

export const customRoute =  {
  template: `
  <router-link :style="getLinkStyle()" :to="{ name: 'watch', params: {sectionId: sectionId, blockId: blockId, videoId: video.id }}">
    <slot name="link">{{ video.title }}</slot>
  </router-link>
`,
  props: [
    'video',
    'sectionId',
    'blockId',
    'fontColor'
  ],

  methods: {
    getLinkStyle() {
      return {
        'color': this.fontColor,
        'text-decoration': 'none',
        'text-decoration-color': this.fontColor
      };
    }
  },
};

export const iconRoute =  {
  template: `
  <router-link :class="aClass" :to="{ name: 'watch', params: {sectionId: sectionId, blockId: blockId, videoId: video.id }}">
    <i :class="iClass"></i>
  </router-link>
`,
  props: [
    'video',
    'sectionId',
    'blockId',
    'aClass',
    'iClass'
  ]
};

export const pageRoute =  {
  template: `
  <router-link :class="aClass" :to="{ name: 'watch', params: {sectionId: sectionId , videoId: video.id }}">
    <i :class="iClass"></i>
  </router-link>
`,
  props: [
    'video',
    'sectionId',
    'aClass',
    'iClass'
  ]
};

export const collectionRoute =  {
  template: `
  <router-link :class="aClass" :to="{ name: 'watch', params: {sectionId: sectionId , videoId: video.id }}">
    <i :class="iClass"></i>
  </router-link>
`,
  props: [
    'video',
    'sectionId',
    'aClass',
    'iClass'
  ]
};

export default {videoRoute, iconRoute, customRoute, pageRoute, collectionRoute};
